export interface EducationEntry {
  dates: string;
  degree: string;
  school: string;
  desc?: string;
  bullets?: string[];
}

export const education: EducationEntry[] = [
  {
    dates: '2018 — 2022',
    degree: 'B.S. Computer Science',
    school: 'Indiana University, Bloomington',
    bullets: [
      'Minor in East Asian Language & Culture',
      'President of 120+ person Veg@IU Student Organization for 3 years',
    ],
  },
];
